import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers/index';
import { Observable } from 'rxjs';
import { SEOService } from '@app/core/services/seo.service';


@Component({
  selector: 'app-suspended',
  templateUrl: './suspended.component.html',
  styleUrls: ['./suspended.component.scss']
})
export class SuspendedComponent {
  hasToken$: Observable<boolean>;

  constructor(
    private readonly store$: Store<fromRoot.State>,
    private seoService: SEOService
  ) {
    this.hasToken$ = this.store$.select(fromRoot.getHasToken);
  }

  ngOnInit() {
    // Seo
    this.seoService.removeHreflang();
  }

}
